export default {
  schedules: {
    type: Array,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/rollback/resources/props.js